import Ajax from "Utils/ajax";
export const getAnnouncementList = (data) => Ajax.post('setting/getAnnouncementList',data); 
export const removeRow = (data) => Ajax.post('setting/deleteAnnouncement',data); 
export const addUpdateAnnouncement = (data) => Ajax.post('setting/addUpdateAnnouncement',data); 
export const getAnnouncementById = (data) => Ajax.post('setting/getAnnouncementById',data); 